export const getNextSiblings = (el, filter) => {
  let siblings = [];
  while (el = el.nextSibling) {
    if (el.nodeType === 3) continue; // Text node
    if (!filter || filter(el)) {
      siblings.push(el);
    }
  }
  return siblings;
}

export const getPreviousSiblings = (el, filter) => {
  let siblings = [];
  while (el = el.previousSibling) {
    if (el.nodeType === 3) continue; // Text node
    if (!filter || filter(el)) {
      siblings.push(el);
    }
  }
  return siblings;
}

export const getAllSiblings = (el, filter) => {
  let siblings = [];
  el = el.parentNode.firstChild;
  do {
    if (el.nodeType === 3) continue; // Text node
    if (!filter || filter(el)) {
      siblings.push(el);
    }
  } while (el = el.nextSibling);
  return siblings;
}



// WEBPACK FOOTER //
// ./src/utils/siblingNodes.js